// extracted by mini-css-extract-plugin
module.exports = {"LandingImageCard":"LandingImageCard-module--LandingImageCard--3dQ1w","title":"LandingImageCard-module--title--3qZir","selected":"LandingImageCard-module--selected--VMLv_"};